import { Box, PaperProps } from '@mui/material'
import { CloseModalIcon } from 'images'
import React, { FC, memo, useCallback, useEffect } from 'react'
import Draggable from 'react-draggable'
import { SHeader, SPaperLarge as SPaper, SDialog, STextField } from './styled'
import { Button } from 'core'

interface ApproveRejectCommentModalProps {
    commentText: string
    setCommentText: React.Dispatch<React.SetStateAction<string>>
    type: 'approve' | 'reject'
    onClose: () => void
    isOpen: boolean
    handleApprove: (comment: string) => Promise<void>
    handleReject: (comment: string) => Promise<void>
}

const ApproveRejectCommentModal: FC<ApproveRejectCommentModalProps> = memo(
    ({ commentText, setCommentText, onClose, isOpen, type, handleApprove, handleReject }) => {
        const nodeRef = React.useRef(null)

        const PaperComponent = useCallback(
            (props: PaperProps) => {
                return (
                    <Draggable
                        handle="#draggable-dialog-title"
                        cancel={'[class*="MuiDialogContent-root"]'}
                        nodeRef={nodeRef}
                    >
                        <SPaper {...props} ref={nodeRef} />
                    </Draggable>
                )
            },
            [nodeRef]
        )

        useEffect(
            () => () => {
                setCommentText('')
            },
            [isOpen]
        )

        return (
            <SDialog
                ref={nodeRef}
                open={isOpen}
                onClose={onClose}
                hideBackdrop
                fullWidth={true}
                aria-labelledby="draggable-dialog-title"
                PaperComponent={PaperComponent}
            >
                <SHeader id="draggable-dialog-title">
                    Comment
                    <Box component="div" sx={{ cursor: 'pointer' }}>
                        <CloseModalIcon
                            onClick={(event) => {
                                event.stopPropagation()
                                onClose()
                            }}
                        />
                    </Box>
                </SHeader>
                <STextField
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    placeholder={'Comment on your response'}
                    multiline
                    rows={2}
                    sx={{
                        '& .MuiOutlinedInput-input': { padding: '0px !important' },
                    }}
                    margin="none"
                />
                {type === 'approve' ? (
                    <Button variant="contained" onClick={() => {
                      handleApprove(commentText);
                      onClose();
                    }}>
                        Approve
                    </Button>
                ) : (
                    <Button variant="contained" onClick={() => {
                      handleReject(commentText);
                      onClose();
                    }}>
                        Reject
                    </Button>
                )}
            </SDialog>
        )
    }
)

export default ApproveRejectCommentModal
